document.addEventListener('customall-script-injected',() => {
    var previewBtn = document.querySelector('.btn.btn-preview')
    var atcBtn = document.querySelector('.btn.btn-add-to-cart')
    atcBtn.before(previewBtn)
    var quantitybox = document.createElement('div')
    quantitybox.classList = 'tee-quantity-group';
    quantitybox.innerHTML = `<span class="tee-quantity-handle tee-quantity-minus">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20">
        <path fill="#444" d="M17.543 11.029H2.1A1.03 1.03 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029s-.463 1.029-1.029 1.029"></path>
        </svg>
    </span>
    <input class="tee-quantity-input" value="1" type="number" name="quantity" min="1" pattern="[0-9]*" placeholder="Qty">
    <span class="tee-quantity-handle tee-quantity-plus">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20">
        <path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071"></path>
        </svg>
    </span>`
    document.querySelector('.cart-qty').insertBefore(quantitybox,document.querySelector('.cart-qty .form-select'))
    document.querySelector('.tee-quantity-plus').addEventListener('click', () => {
        var oldVal = parseInt(document.querySelector('.tee-quantity-input').value)
        document.querySelector('.tee-quantity-input').value = oldVal + 1
        document.querySelector('.cart-qty .form-select').value = oldVal + 1
    })
    document.querySelector('.tee-quantity-minus').addEventListener('click', () => {
        var oldVal = parseInt(document.querySelector('.tee-quantity-input').value)
        if(oldVal == 1)return;
        document.querySelector('.tee-quantity-input').value = oldVal - 1;
        document.querySelector('.cart-qty .form-select').value = oldVal - 1
    })
    document.querySelector('.btn.btn-preview').addEventListener('click',() => {
        if(document.querySelector('.preview-header .sub-content') == null) {
            document.querySelector('.preview-header').innerHTML += `<p class="sub-content">Make sure the below customization is correct to receive your item faster</p>`
        }
        setTimeout(() => {
            if(document.querySelector('.preview-header h3') != null) {
                document.querySelector('.preview-header h3').innerText = 'Please check the preview carefully'
            }
        },500)
    })
    if (
        document.querySelector(".product__info-container") != null
      ) {
        var preview = document.createElement("div");
        preview.classList = "btn-preview hidden-xl";
        preview.innerHTML = `<a id="btn-preview" href="#teeFormActions" class="button customily-preview-button">Preview Your Personalization</a>`;
        document.querySelector(".product__info-container").appendChild(preview);
        document.getElementById("btn-preview").addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector('.nf-product-single button.btn-preview').click()
        });
      }
})